import { openLink } from "../../../../functions/functions";
import './footerCard.sass';

/**
 * Componente footer para tarjetas de eventos deportivos
 * Muestra la ubicación del evento y permite navegar a estadísticas si está disponible
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.estadio - Nombre del estadio o venue
 * @param {string} props.ciudad - Ciudad donde se realiza el evento
 * @param {string} props.estado - Estado o región del evento
 * @param {string} props.opta_event_url - URL opcional para estadísticas del evento
 * @param {boolean} props.mostrarBotonApostarCard - Controla la visibilidad del botón de apuestas
 * @param {boolean} props.isStrendus - Determina el estilo del botón según la casa de apuestas
 * @param {string} props.apostarHref - URL para el botón de apuestas
 * 
 * @returns {JSX.Element|null} Footer con ubicación o null si no hay datos
 */
export default function FooterCard({
  estadio = "",
  ciudad = "",
  estado = "",
  opta_event_url = "",
  clase = "",
  period_title = ""
}) {
  /**
   * Trunca una cadena si supera 29 caracteres
   * @param {string} text - Texto a truncar
   * @returns {string} Texto truncado con "..." si es necesario
   */
  const truncateText = (text, isNext) => {
    return text.length > 29 && !isNext ? text.substring(0, 29) + "..." : text;
  };

  /**
   * Determina si hay URL disponible para estadísticas
   */
  const hasUrl = Boolean(opta_event_url);

  /**
   * Determina el estado del juego y el texto a mostrar
   */
  const cls = String(clase).toLowerCase().trim();
  const isLive = cls === "clarosports-in-progress-game";
  const isFinished = cls === "clarosports-finished-game";
  const isError = cls === "clarosports-error-game";
  const isNext = cls === "clarosports-next-game";

  // muesta el estatus del partido
  const getStatusText = () => {
    if (isLive) return period_title + " ● EN VIVO";
    if (isFinished || isError) return period_title;
    return "";
  };

  // asigna la clase correspondiente dependiendo del status
  const getStatusClass = () => {
    if (isLive) return "card-footer--live";
    if (isFinished) return "card-footer--finished";
    if (isError) return "card-footer--error";
    if (isNext) return "card-footer--next";
    return "";
  };

  /**
 * Construye la cadena de ubicación filtrando valores vacíos
 * Combina estadio, ciudad y estado en formato: "Estadio, Ciudad, Estado"
 */
  const location = truncateText([estadio, ciudad, estado].filter(Boolean).join(", "), isNext);

  // No renderizar si no hay información de ubicación
  if (!location && isNext) return <div className="card-footer-none"></div>;

  return (
    <div
      className={`card-footer ${getStatusClass()} ${hasUrl ? 'clickable' : ''}`}
      onClick={() => openLink(opta_event_url, true)}
      role={hasUrl ? "button" : undefined}
      tabIndex={hasUrl ? 0 : undefined}
      aria-label={hasUrl ? `Ver evento` : undefined}
      title={hasUrl ? "Click para ver el evento" : undefined}
      onKeyDown={hasUrl ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openLink(opta_event_url, true)
        }
      } : null}
    >

      {/* Ubicación - Centro */}
      <div className="card-footer-location">
        <p>{location}</p>
      </div>

      {/* Estado del juego - Derecha */}
      {getStatusText() && (
        <span className="card-footer-status">{getStatusText()}</span>
      )}
    </div>)
}